// users.johaisetsu_role / users.cleaning_role の文字列から利用区分を取り出す。
// 判定はバックエンドの App\ValueObjects\UserAffiliation と同じ
export const USAGE_TYPE_OFFICE = 'office';
export const USAGE_TYPE_PARTNER_DRIVER = 'partner_driver';
export const USAGE_TYPE_SHUTOKOU_DIRECT_DRIVER = 'shutokou_direct_driver';
export type UsageType = typeof USAGE_TYPE_OFFICE | typeof USAGE_TYPE_PARTNER_DRIVER | typeof USAGE_TYPE_SHUTOKOU_DIRECT_DRIVER;

const SHUTOKOU_DIRECT_DRIVER_ROLE_KEY = 'driver';
const DRIVER_SUFFIX = '_driver';

export function getUsageType(roleKey: string | null): UsageType | null {
  if (!roleKey) return null;
  if (roleKey === SHUTOKOU_DIRECT_DRIVER_ROLE_KEY) return USAGE_TYPE_SHUTOKOU_DIRECT_DRIVER;
  if (roleKey.endsWith(DRIVER_SUFFIX)) return USAGE_TYPE_PARTNER_DRIVER;
  return USAGE_TYPE_OFFICE;
}

// 協力会社ドライバーか首都高直営ドライバーのいずれか
export function isAnyDriver(roleKey: string | null): boolean {
  return isPartnerCompanyDriver(roleKey) || isShutokouDirectDriver(roleKey);
}

export function isPartnerCompanyDriver(roleKey: string | null): boolean {
  return getUsageType(roleKey) === USAGE_TYPE_PARTNER_DRIVER;
}

export function isShutokouDirectDriver(roleKey: string | null): boolean {
  return getUsageType(roleKey) === USAGE_TYPE_SHUTOKOU_DIRECT_DRIVER;
}
